import { render, staticRenderFns } from "./employeeconversation.vue?vue&type=template&id=3bc1fcc5&"
import script from "./employeeconversation.vue?vue&type=script&lang=ts&"
export * from "./employeeconversation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "employeeconversation.vue"
export default component.exports